'use client'

import s from './Pagination.module.scss';
import {ArrowIcon} from "@/app/[locale]/common/assets/ArrowIcon/ArrowIcon";
import {TPaginationProps} from "@/app/[locale]/common/components/Pagination/types";
import {useState} from "react";
import {generatePageArray} from "@/app/[locale]/common/utils/generatePageArray/generatePageArray";
import {INDEX_COUNT, ELEMENT_INDEX} from "../../constants/app";
import {PAGE_COUNT, PAGE_NUMBER} from "../../constants/pagination";
import {useRouter} from "next/navigation";
import {useLocale} from "next-intl";

export const Pagination = (
    {
        type,
        currentPage,
        numberPages,
    }: TPaginationProps) => {
    const router = useRouter();
    const locale = useLocale();
    const [ page, setPage ] = useState(currentPage);
    const [visiblePages, setVisiblePages] = useState<number[]>(generatePageArray(PAGE_COUNT.FIRST, Math.min(PAGE_COUNT.FIFTH, numberPages)));

    const handlePageChange = (page: number) => {
        setPage(page);
        router.push(`/${locale}/${type}?page=${page}`);
    };

    const leftButtonDisabled = visiblePages[ELEMENT_INDEX.FIRST] === PAGE_COUNT.FIRST;
    const rightButtonDisabled = visiblePages[visiblePages.length - INDEX_COUNT.ONE] === numberPages;

    const handleNext = () => {
        const indexLastPage = visiblePages.length - INDEX_COUNT.ONE;
        if (visiblePages[indexLastPage] < numberPages) {
            setVisiblePages((prev) =>
                generatePageArray(prev[ELEMENT_INDEX.FIRST] + PAGE_NUMBER.ONE, Math.min(prev[prev.length - INDEX_COUNT.ONE] + PAGE_NUMBER.ONE, numberPages))
            );
        }
    };

    const handlePrev = () => {
        if (visiblePages[ELEMENT_INDEX.FIRST] > PAGE_COUNT.FIRST) {
            setVisiblePages((prev) =>
                generatePageArray(Math.max(prev[ELEMENT_INDEX.FIRST] - PAGE_NUMBER.ONE, PAGE_NUMBER.ONE), prev[prev.length - INDEX_COUNT.ONE] - PAGE_NUMBER.ONE)
            );
        }
    };

    return (
        <nav className={s.pagination}>
            <button
                className={`${s.pagination_button} ${s.pagination_button_left}`}
                onClick={handlePrev}
                disabled={leftButtonDisabled}
            >
                <ArrowIcon disabled={leftButtonDisabled} />
            </button>
            <div className={s.pagination_container}>
                {visiblePages.map((num: number, index: number) => (
                    <button
                        key={index}
                        className={`${s.pagination_container_button} ${
                            page === num && s.pagination_container_button_active
                        }`}
                        onClick={() => handlePageChange(num)}
                    >
                        {num}
                    </button>
                ))}
            </div>
            <button
                className={`${s.pagination_button} ${s.pagination_button_right}`}
                onClick={handleNext}
                disabled={rightButtonDisabled}
            >
                <ArrowIcon disabled={rightButtonDisabled} />
            </button>
        </nav>
    );
};